import { Quiz } from "./Quiz/Quiz";
import { OverlaySubscribe } from "./Overlay/OverlaySubscribe";
import { OverlayDeleteParticipant } from "./Overlay/OverlayDeleteParticipant";
import { Search } from "./Search/Search";

export const Components = {
  Quiz,
  OverlayDeleteParticipant,
  OverlaySubscribe,
  Search,
};
